<template>
  <div v-if="executor" class="trip-main">
    <modal-dialog v-model:show="showModal">
      <div class="modal-content">
        <h4>Отправить данные в ТМС?</h4>
        <div>
          <button @click="sendToTMS" class="save-button">Да</button>
          <button @click="showModal=false" class="delete-btn">Нет</button>
        </div>
      </div>
    </modal-dialog>
    <div class="center">
      <h4 >Назначен исполнитель: № {{ executor.id }}</h4>
      <button
      v-if="!delConfirm"
      @click="delConfirm=true"
      class="delete-btn"
      >Удалить</button>
      <div v-if="delConfirm">
        <button @click="deleteExecutor" class="save-button">Да</button>
        <button @click="delConfirm=false" class="delete-btn">Нет</button>
      </div>
    </div>

    <TmsSyncedBadge :trip="trip" :executor="executor" />
    <TmsOwnershipNote :executor="executor" />
    <div class="trip-data">
      <CardCarExecitor :car="executor.car" @updateExecutor="sendForm" />
      <CardTreilerExecitor v-if="executor.trailer" :trailer="executor.trailer" @updateExecutor="sendForm" />
      <CardDriverExecitor :driver="executor.driver" @updateExecutor="sendForm"/>
      <CardCompanyExecetor
      :company="executor.company"
      @updateExecutor="sendForm"
      :bank_default="executor.bank_details"
      :bank_default_id="executor.bank_detail_id"
      @sendOrder="sendOrder"
      @updateBank="updateBank"
      @ExecutorRoute="$router.push('/executors/'+executor.id)"/>
    </div>
    <div class="edo-info">
      <span>ЭДО ID</span>
      <strong v-if="!redactExecutor">{{ executor.edo_id || '-' }}</strong>
      <input v-else class="form-input" v-model="forms.executors.edo_id">
      <button v-if="!redactExecutor" class="redact-btn" @click="redactExecutor=true">Изменить</button>
      <template v-else>
        <button class="redact-btn" @click="redactExecutor=false">Отмена</button>
        <button class="redact-btn" @click="saveForm('executors')">Сохранить</button>
      </template>
    </div>

    <div>
      <button
      v-if="!application || !application.is_sent"
      class="save-button"
      >Отправить заявку</button>
    </div>

    <div v-if="trip.work_status && trip.work_status.name !== 'В пути' && trip.work_status.name !== 'Закрыт' " class="tms-button-send">
      <h4>Работа с ТМС</h4>
      <div v-if="sendTmsSuccess" class="flex-row">
        <div class="tms-block-info">
          <div class="send-tms-candidat">
            <h5 v-if="trip.is_candidate_attached">В процессе добавления</h5>
            <h5 v-if="trip.is_tms_candidate">Исполнитель добавлен</h5>
            <h5 v-else-if="trip.is_tms_failed_candidate">Добавлен случайный исполнитель</h5>
            <button
              @click="confirmed('candidate')"
              class="save-button">
              <span v-if="!trip.is_tms_candidate">Добавить исполнителя</span>
              <span v-else>Добавить нового</span>
            </button>
          </div>
        </div>
        <div>
          <h5 v-if="trip.is_tms_attorney">Доверенность добавлена</h5>
          <h5 v-else-if="!trip.is_tms_attorney && trip.attorney_name">Доверенность отправлена в очередь</h5>
          <button
            v-if="executor.is_success"
            class="save-button"
            @click="confirmed('attorney')">
            <span v-if="!trip.is_tms_attorney">Загрузить доверенность</span>
            <span v-else>Загрузить повторно</span>
          </button>
          <div v-else>
            <button class="disabled-button" disabled>
              Загрузить доверенность
            </button>
            <div class="attorey-message">
              <p>Нельзя загрузить доверенность,</p>
              <p>подтвердите проверку</p>
              <div>
                <a class="link-executor" @click="$router.push('/executors/'+executor.id)">Исполнителя №: {{executor.id}}</a>
              </div>
            </div>
          </div>
        </div>

      </div>

      <div v-else>
        <p>Не готов к внесению</p>
      </div>
    </div>
  </div>
</template>

<script>
import { saveExecutorForm } from '@/pages/trip/helpers/saveExecutorForm.mjs'
import { useRoute } from 'vue-router'
import { ref,computed } from 'vue'
import { useStore } from 'vuex';
import executors from '@/store/modules/executors';
import { faL } from '@fortawesome/free-solid-svg-icons';
import TmsSyncedBadge from '@/components/TmsSyncedBadge.vue';
import TmsOwnershipNote from '@/components/TmsOwnershipNote.vue';

export default {
  name: 'ExecutorTripInfoLegacy',
  components: { TmsSyncedBadge, TmsOwnershipNote },
  props: ['trip','executor'],
  setup(props,{emit}){

    const store = useStore()
    store.dispatch('applications/getApplication',props.trip.id)


    const route = useRoute()

    const redactDriver = ref(false)
    const redactCompany = ref(false)
    const redactTrailer = ref(false)
    const redactCar = ref(false)
    const redactExecutor = ref(false)
    const delConfirm = ref(false)
    const sendConfirm = ref(null)
    const showModal = ref(false)

    const application = computed(()=>store.state.applications.currentApp)

    const correctFormTms = ref({
      inn_driver:'',
      type:'',
      id:null,
    })

    const confirmed = type =>{
      sendConfirm.value = type
      showModal.value = true
    }

    const sendToTMS = () => {
      correctFormTms.value.type = sendConfirm.value
      emit('sendTMS',correctFormTms.value.type)
      showModal.value = false
      sendConfirm.value = null
      correctFormTms.value.inn_driver = ''
      correctFormTms.value.type = ''
    }

    const forms = ref({
      executors:{
        id:props.executor.id,
        edo_id:props.executor.edo_id || '',
      },
      drivers:{
        id:props.executor.driver.id,
        phone:props.executor.driver.phone,
        birthday:props.executor.driver.birthday,
        passport:props.executor.driver.passport,
        license:props.executor.driver.license,
        inn:props.executor.driver.inn,
        passport_issued:props.executor.driver.passport_issued,
        passport_date:props.executor.driver.passport_date,
      },
      cars:{
        id:props.executor.car.id,
        number:props.executor.car.number,
        vin:props.executor.car.vin,
        ownerPhone:props.executor.car.ownerPhone,
        brand_name:props.executor.car.security_info[0].avtocod_identifiers_brand_name
      },
      companies:{
        id:props.executor.company.id,
        name:props.executor.company.name,
        director:props.executor.company.director,
        ogrn:props.executor.company.ogrn,
        inn:props.executor.company.inn
      },
    })

    if(props.executor.trailer){
      forms.value.trailers = {
        id:props.executor.trailer.id,
        number:props.executor.trailer.number,
        vin:props.executor.trailer.vin,
        ownerPhone:props.executor.trailer.ownerPhone,
        brand_name:props.executor.trailer.security_info[0].avtocod_identifiers_brand_name
      }
    }

    const openClose = btn =>{
      if(btn == 'redactDriver'){
        redactDriver.value = !redactDriver.value
        redactTrailer.value = false
        redactCompany.value = false
        redactCar.value = false
      }
      else if(btn == 'redactTrailer'){
        redactTrailer.value = !redactTrailer.value
        redactDriver.value = false
        redactCompany.value = false
        redactCar.value = false
      }
      else if(btn == 'redactCompany'){
        redactCompany.value = !redactCompany.value
        redactDriver.value = false
        redactTrailer.value = false
        redactCar.value = false
      }
      else if(btn == 'redactCar'){
        redactCar.value = !redactCar.value
        redactDriver.value = false
        redactTrailer.value = false
        redactCompany.value = false
      }
    }

    const saveForm = async name =>{
      let model = name
      if(name == 'trailers'){model = 'cars'}
      const saved = await saveExecutorForm(emit, { form: forms.value[name], model })
      if (!saved) return
      redactDriver.value = false
      redactTrailer.value = false
      redactCompany.value = false
      redactCar.value = false
      redactExecutor.value = false
    }

    const updateBank = (id) =>{
      const form = {
        id:props.executor.id,
        bank_detail_id:id,
      }
      emit('updateExecutor',{form,model:'executors'})
    }

    const sendForm = async ({form,model,onSaved}) =>{
      const saved = await saveExecutorForm(emit, { form, model })
      onSaved?.(saved)
    }

    const deleteExecutor = ()=>{
      store.dispatch('cargos/updateStatus',{link:route.params.id+'/executor/delete'})
    }

    const sendOrder = ()=>{
      emit('sendOrder')
    }

    const existTmsId = (name)=>{
      if(props.trip.trip_id.length === 10){
        return props.executor[name].tms_id
      }else{
        return props.executor[name].candidate_id
      }
    }
    const sendTmsSuccess = computed(()=>{
      if (props.executor.car.tms_id && props.executor.driver.tms_id){
        if(props.executor.trailer && props.executor.trailer.tms_id){
          return true
        }
      }
      return false
    })

    return{
      sendOrder,
      updateBank,
      sendForm,
     sendTmsSuccess,
     existTmsId,
     correctFormTms,
     showModal,
     confirmed,
     delConfirm,
     deleteExecutor,
     redactDriver,
     redactCompany,
     redactTrailer,
      redactCar,
      redactExecutor,
     openClose,
     saveForm,
     forms,
     sendToTMS,
     application,
    //  application:computed(()=>store.state.application.tripPage.comments),
    }
  }
};
</script>

<style scoped>

.status-label{
  margin-top: 20px;
}

.send-tms-candidat{
  display: flex;
  align-items: flex-start;
  flex-direction: column;
}

.trip-main{
  padding: 25px 10px;
  border-radius: 10px;
  margin-top: 15px;
  border: 1px solid #ccc;

}

.trip-data {
  margin-top: 30px;
  display: flex;
  justify-content: space-between;
}

.edo-info{
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 12px 5px 0;
}

.content-block{
  border: 1px solid #ccc;
  border-radius: 25px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  font-size: 13px;
  margin: 5px;
  flex: 1; /* Добавьте это свойство, чтобы блоки занимали одинаковое пространство */
/*  padding: 10px; */
  box-sizing: border-box; /* Учтите отступы внутри блоков */
}

.content-fields{
  display: flex;
  flex-direction: column;
  align-items: center;
}

.content-buttons{
  display: flex;
  flex-direction: column;
  align-items: center;
}

.flex-row{
  margin-top: 15px;
  display: flex;
  flex: 1;
  justify-content: space-between;
}


.content-block div {
  width: 100%;
}

.white-text{
  color: white;
  padding: 1px;
}

.item-info{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 2px;
}
.center{
  margin-left: 30px;
  margin-bottom: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.button-container {
  margin-top: auto;
  display: flex;
  justify-content: center;
  align-items: center;
}

.redact-btn {
  padding: 4px;
  margin-left: 5px;
  margin-bottom: 10px;
  border-radius: 5px;
  border: 1px solid #ccc;
}

.link-executor{
  color: blue;
  font-size: 15px;
  border-bottom: 1px solid;
}


.link-executor:hover{
  cursor: pointer;
}

.mt-10{
  margin-top: 10px;
}

.form-input{
  padding: 2px;
  border-radius: 3px;
  border: 1px solid #ccc;
  margin-bottom: 3px;
  width: 160px;
}
.icon{
  margin-top: 5px;
  width: 20px;
  height: 20px;
  color: #ee2b2b;
}

.text-content{
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 2px 15px ;
}

.tms-button-send{
  margin-top: 20px;
  text-align: center;
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 10px;
}

.tms-message{
  text-align: center;
  margin-top: 25px;
  margin-bottom: 15px;
  margin-right: 10px;
  font-size: 13px;
}

.message{
  display: flex;
  flex-direction: column;
}

.form-item{
  display: flex;
  flex-direction: column;
}

.attorey-message{
  margin-top: 10px;
  font-size: 12px;
  color: red;
}

.attorey-message div{
  margin-top: 5px;
}

.save-button {
  margin-right: 5px;
  margin-top: 2px;
  padding: 5px 12px;
  background-color: #007bff;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.disabled-button{
  margin-right: 5px;
  margin-top: 2px;
  padding: 5px 12px;
}

.delete-btn {
  padding: 5px 8px;
  border: 1px solid #C33245;
  border-radius: 4px;
  background-color: #C33245;
  color: #fff;
  cursor: pointer;
}

.modal-content{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.td-line{
  border-bottom: 1px solid #ccc;
}

.error-msg{
  text-align: center;
  color: rgba(255,105,116, 1.0);
  margin-top: 5px;
  margin-bottom: 15px;
  margin-left: 3px;
}


.tms-block-info h5 {
  margin-bottom: 5px;
  /* margin-left: 10px; */
}

.mr-t-30{
  margin-top: 30px;
}
</style>
